import { render, staticRenderFns } from "./TestingCenterTimePage.vue?vue&type=template&id=40a0ce53&"
import script from "./TestingCenterTimePage.vue?vue&type=script&lang=ts&"
export * from "./TestingCenterTimePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports